import React from 'react'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {MasiveUploadEnterprise} from '../form/masive'
import {TableEnterprise} from './Columns'
import CustomContentTabs from '../../../../../../components/UI/Tab/content'

const TableEnterpriseWrapper = () => {
  const {isAllowed} = useCentral()

  const tabs = [
    {
      label: 'Listado de Empresa',
      component: <TableEnterprise />,
    },
    isAllowed('MASIVO') && {
      label: 'Carga Masiva',
      component: <MasiveUploadEnterprise />,
    },
  ].filter(Boolean)
  return (
    <KTableProvider>
      <CustomContentTabs tabs={tabs} />
    </KTableProvider>
  )
}

export {TableEnterpriseWrapper}
